import { useEffect, useState } from "react";
import { OnboardingApplicationLogTab } from "../types";
import { useApplicationTableResourceContext } from "../../../ApplicationTableResourceProvider";

export const useOnboardingApplicationLogsTab = (initialState = OnboardingApplicationLogTab.Step) => {
    const [value, setValue] = useState<string>(initialState);

    const { open } = useApplicationTableResourceContext();

    useEffect(() => {
        if (!open) {
            setValue(OnboardingApplicationLogTab.Step);
        }
    }, [open]);

    return {
        value,
        onChange: setValue
    };
};
